import { COMPANY_CONFIG_ACTIONS } from '@/modules/company/entities/enums/company';
import {
  CompanyConfig,
  CompanyConfigToSave,
  CompanyListResponse,
  CompanyTreeResponse,
  ParamsToFilterCompanies,
  RequestActionBulkCompanyConfigs,
} from '@/modules/company/entities/interfaces/company';
import { CompanyContact } from '@/modules/company/entities/interfaces/CompanyContact';
import { ListResponse } from '@/shared/hooks/useRequestData/useRequestPaginatedList';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

class CompanyService extends HttpClientAdapter {
  constructor() {
    super('NEGOTIATION');
  }

  getCompaniesTree<T = CompanyTreeResponse>(companyIds: string[]) {
    return this.get<T>('/companies', {
      withTree: true,
      id: companyIds,
    });
  }

  getCompanies<T = CompanyListResponse>(filters?: Partial<ParamsToFilterCompanies>) {
    return this.get<T>('/companies', filters);
  }

  getContacts<T = ListResponse<CompanyContact>>(companyId: string) {
    return this.get<T>(`/companies/${companyId}/contacts`);
  }

  saveManyCompanyConfigs(companyConfigs: CompanyConfigToSave[]) {
    return this.post<CompanyConfig[], RequestActionBulkCompanyConfigs>('/bulk-company-configs', {
      action: COMPANY_CONFIG_ACTIONS.CREATE,
      items: companyConfigs,
    });
  }

  deleteManyCompanyConfigs(companyConfigs: CompanyConfigToSave[]) {
    return this.post<undefined, RequestActionBulkCompanyConfigs>('/bulk-company-configs', {
      action: COMPANY_CONFIG_ACTIONS.DELETE,
      items: companyConfigs,
    });
  }
}

export default CompanyService;
